export default class MobileNavigation {
    constructor() {
        const itemWithSubMenuArray = document.querySelectorAll('.item--with-sub-menu');
        
        itemWithSubMenuArray.forEach(function(itemWithSubMenu) {
            const itemHeadlineMainMenu = itemWithSubMenu.querySelector('#item-headline-main')
            const itemHeadlineSubMenu = itemWithSubMenu.querySelector('#item-headline-sub')

            itemHeadlineMainMenu.addEventListener('click', function () {
                itemWithSubMenu.classList.add('item--with-sub-menu--active')
            })

            itemHeadlineSubMenu.addEventListener('click', function () {
                itemWithSubMenu.classList.remove('item--with-sub-menu--active')
            })
        })
    }
}
